import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getScheduledPodcastsByMeetingId } from "../Services/SchedulesApi";
import { useLocation } from "react-router-dom";
import { commonConstants } from "../utils/constant";

const AIAssistantPanel = () => {

    const [schedule, setSchedule] = useState();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const meetingId = queryParams.get("meetingId");

    useEffect(() => {
        const fetchSchedule = async () => {
            try {
                // Fetch podcast details
                const response = await getScheduledPodcastsByMeetingId(meetingId); // API call to fetch podcasts
                console.log("AIassist", response)
                setSchedule(response?.data?.Data[0]); // Update podcasts data

            } catch (error) {
                console.error("Error fetching podcasts:", error); // Error handling
            } finally {
                // setLoading(false); // End loading after the fetch is complete
            }
        };

        fetchSchedule();
    }, []);

    const accordionStle = {
        backgroundColor: '#ffffff10',
        color: 'white',
        borderRadius: '1.0vh',
        borderTopLeftRadius: '1.0vh !important',
        borderTopRightRadius: '1.0vh !important',
        fontSize: '1.4vh',
    }

    const renderImportantLinks = (linksString) => {
        if (!linksString?.trim()) {
            return <div>{commonConstants.NO_IMP_LINK}</div>;
        }

        const links = linksString
            .trim()
            .split(',')
            .map(link => link.trim())
            .filter(link => link !== '');

        const validLinks = links.reduce((acc, link) => {
            try {
                const url = new URL(link.startsWith('http') ? link : `https://${link}`);
                acc.push(
                    <a
                        key={link}
                        href={url.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        title={link}
                        style={{ fontSize: '1.3vh', color: 'white' }}
                    >
                        {url.hostname}
                    </a>
                );
            } catch {
                console.log("invalid links")
            }
            return acc;
        }, []);

        return validLinks.length > 0 ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.6vh', paddingLeft: '1.2vh' }}>
                {validLinks}
            </div>
        ) : (
            <div>{commonConstants.NO_IMP_LINK}</div>
        );
    };

    return (
        <Box color='white' style={{ display: 'flex', flexDirection: 'column', gap: '1.2vh', padding: '1.2vh' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.2vh' }}>
                <Accordion
                    sx={accordionStle}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: 'white', fontSize: '2vh' }} />}
                        style={{ fontSize: '1.4vh' }}
                    >
                        Agenda
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{ maxHeight: '40vh', overflowY: 'auto', fontSize: '1.3vh' }}>
                            {schedule?.Agenda ? (
                                <div dangerouslySetInnerHTML={{ __html: schedule?.Agenda }} />
                            ) : (
                                <div>
                                    {commonConstants.NO_AGENDA}
                                </div>
                            )}
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    sx={accordionStle}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: 'white', fontSize: '2vh' }} />}
                        style={{ fontSize: '1.4vh' }}
                    >
                        Guest Details
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{ maxHeight: '40vh', overflowY: 'auto', fontSize: '1.3vh' }}>
                            {schedule?.GuestInfo ? (
                                <div dangerouslySetInnerHTML={{ __html: schedule?.GuestInfo }} />
                            ) : (
                                <div>
                                    {commonConstants.No_GUEST_INFO}
                                </div>
                            )}
                        </div>
                    </AccordionDetails>
                </Accordion>

                <Accordion
                    sx={accordionStle}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon style={{ color: 'white', fontSize: '2vh' }} />}
                        style={{ fontSize: '1.4vh' }}
                    >
                        Quick Links
                    </AccordionSummary>
                    <AccordionDetails>
                        <div style={{ maxHeight: '40vh', overflowY: 'auto', fontSize: '1.3vh' }}>
                            {renderImportantLinks(schedule?.ImportantLinks)}
                        </div>
                    </AccordionDetails>

                </Accordion>
            </div>
        </Box>
    );
};

export default AIAssistantPanel;
